import countMainNavTodos from 'components/molecules/HeaderNav/additions/countTodos';
import countOffCanvasTodos from 'components/molecules/OffCanvas/additions/countTodos';

export type NavigationRouteItem = {
	id: string;
	route?: string;
	additions?: Array<any>;
};

export const offCanvasRouteIds: Array<NavigationRouteItem> = [
	{ id: 'dashboard' },
	{ id: 'today', route: 'day', additions: [countOffCanvasTodos] },
	{ id: 'mySuccess' },
	{ id: 'program', route: 'recommended' },
	{ id: 'profile' },
	{ id: 'favorites' },
];

export const headerNavRouteIds: Array<NavigationRouteItem> = [
	{ id: 'dashboard' },
	{ id: 'today', route: 'day', additions: [countMainNavTodos] },
	{ id: 'mySuccess' },
	{ id: 'program', route: 'recommended' },
];
